import { theme } from '@dojo/framework/core/middleware/theme';
import { create, v } from '@dojo/framework/core/vdom';
import css from '../../css/micro.m.css';
const factory = create({
    theme
})
    .properties()
    .children();
export const MicroCredentialCard = factory(({ id: widgetId, properties, children, middleware: { theme } }) => {
    const { root } = theme.classes(css);
    const id = 'micro-credential-card';
    const { xqa = `${id}-container` } = properties();
    let { leading, trailing, actions } = children()[0];
    if (!Array.isArray(leading)) {
        leading = [leading];
    }
    if (!Array.isArray(trailing)) {
        trailing = [trailing];
    }
    if (!Array.isArray(actions)) {
        actions = [actions];
    }
    return v('div', { widgetId, id, xqa, key: `${id}-${widgetId}`, classes: [theme.variant()] }, [
        v('div', { classes: [root] }, [v('div', {}, leading), v('div', {}, trailing)]),
        v('div', {}, [v('div', {}, actions)])
    ]);
});
export default MicroCredentialCard;
